<mat-tab-group [@.disabled]="true">

    <mat-tab>
        <ng-template mat-tab-label>
            M1
            <!-- <img src="assets/math/ppt.svg" alt=""> -->
        </ng-template>
        <ng-template matTabContent>
            <div>
                <nsm1></nsm1>
            </div>
        </ng-template>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            M2
        </ng-template>

        <ng-template matTabContent>
            <div>
                <nsm2></nsm2>
            </div>
        </ng-template>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            p2/p1
        </ng-template>

        <ng-template matTabContent>
            <div>
                <nsp2p1></nsp2p1>
            </div>
        </ng-template>
    </mat-tab>


    <mat-tab>
        <ng-template mat-tab-label>
            T2/T1
        </ng-template>

        <ng-template matTabContent>
            <div>
                <nst2t1></nst2t1>
            </div>
        </ng-template>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            ΔV/a1
        </ng-template>

        <ng-template matTabContent>
            <div>
                <nsdva1></nsdva1>
            </div>
        </ng-template>
    </mat-tab>




</mat-tab-group>